import { MetaProps, ArticleWithAuthor } from '../../../../types/IHeader';
import { siteUrl } from '..';

export const article = (
  data: MetaProps,
  localSlug: string,
  uri: string,
): ArticleWithAuthor => {
  const author = data?.hero?.[0]?.author;
  return {
    '@type': 'Article',
    '@id': `${siteUrl}${uri}#article`,
    isPartOf: {
      '@id': `${siteUrl}${uri}`,
    },
    author: {
      name: author?.name || 'Payfit',
      '@id': author?.name
        ? `${siteUrl}/#/schema/person/${author?.name?.replace(/ /g, '-')}`
        : `${siteUrl}/${localSlug}#organization`,
    },
    headline: data?.metaFields?.title,
    datePublished: data?.date,
    dateModified: data?.meta?.updatedAt,
    mainEntityOfPage: {
      '@id': `${siteUrl}${uri}`,
    },
    publisher: {
      '@id': `${siteUrl}/${localSlug}#organization`,
    },
    image: {
      '@id': `${siteUrl}${uri}#primaryimage`,
    },
    thumbnailUrl: data?.hero?.[0]?.image?.url,
    keywords: [],
    copyrightHolder: {
      '@id': `${siteUrl}/${localSlug}#organization`,
    },
  };
};
